/**
 * Service to handle authentication-related operations
 */
class AuthService {
    /**
     * Check if the user is still authenticated
     * @returns A promise that resolves to a boolean indicating if the user is authenticated
     */
    static async checkAuthentication(): Promise<boolean> {
      try {
        const response = await fetch(`${boardMemberData.restURL}board-member/v1/check-auth`, {
          headers: {
            'X-WP-Nonce': boardMemberData.nonce,
          },
        });
  
        if (!response.ok) {
          return false;
        }
  
        // If we get a successful response, refresh the nonce
        const data = await response.json();
        if (data.success && data.new_nonce) {
          this.updateNonce(data.new_nonce);
        }
  
        return true;
      } catch (error) {
        console.error('Error checking authentication:', error);
        return false;
      }
    }
  
    /**
     * Update the WordPress REST API nonce
     * @param newNonce The new nonce value
     */
    static updateNonce(newNonce: string): void {
      if (boardMemberData) {
        boardMemberData.nonce = newNonce;
      }
    }
  
    /**
     * Redirect to the login page
     * @param redirectTo Optional URL to redirect to after login
     */
    static redirectToLogin(redirectTo?: string): void {
      const currentPath = redirectTo || (window.location.pathname + window.location.search);
      window.location.href = `${boardMemberData.loginURL}?redirect_to=${encodeURIComponent(currentPath)}`;
    }
  
    /**
     * Handle a session timeout
     */
    static handleSessionTimeout(): void {
      // You could show a modal, redirect, or take other actions here
      // For now, we'll just redirect to the login page
      this.redirectToLogin();
    }
  }
  
  export default AuthService;